<tam-dialog
    tid="relationship_automationn_dialog"
    [opened]="opened"
    dialogWidth="855px"
    contentHeight="500"
    titleName="{{ 'workflow.tamale_automation' | stringLiterals }} - {{
        'workflow.create_relationships' | stringLiterals
    }}"
    (keydown.esc)="onCancelBtnClick($event)"
    class="automation-dialog-container"
>
    <ng-template #title>
        <span class="dialog-title"
            >{{ "workflow.tamale_automation" | stringLiterals }} -
            {{ "workflow.create_relationships" | stringLiterals }}</span
        >
        <smart-icon
            class="dialog-close dark"
            name="close"
            (click)="onCancelBtnClick($event)"
        >
        </smart-icon>
    </ng-template>
    <ng-template #body>
        <div class="bodyContainer">
            <div class="dynamic-rows-container">
                <div
                    class="relation-row-wrapper"
                    *ngFor="let relationItem of relationshipSettings"
                >
                    <div class="fld-parent-col">
                        <kendo-combobox
                            #dropDownParentEntity
                            [(ngModel)]="
                                relationItem.parentDataSource.selectedValue
                            "
                            [filterable]="true"
                            textField="key"
                            valueField="value"
                            (filterChange)="
                                handleSingleFilterChanged(
                                    $event,
                                    relationItem.parentDataSource
                                )
                            "
                            [data]="
                                relationItem.parentDataSource.filteredDataSource
                            "
                            placeholder="{{
                                relationItem.parentDataSource.placeholder
                            }}"
                            (selectionChange)="onFieldSelectionChange($event)"
                            (focus)="dropDownParentEntity.toggle(true)"
                        >
                        </kendo-combobox>
                    </div>
                    <div class="relation-type-col">
                        <kendo-combobox
                            #dropDownRelationType
                            [(ngModel)]="
                                relationItem.relationshipTypeDataSource
                                    .selectedValue
                            "
                            [filterable]="true"
                            textField="key"
                            valueField="value"
                            (filterChange)="
                                handleSingleFilterChanged(
                                    $event,
                                    relationItem.relationshipTypeDataSource
                                )
                            "
                            [data]="
                                relationItem.relationshipTypeDataSource
                                    .filteredDataSource
                            "
                            placeholder="{{
                                relationItem.relationshipTypeDataSource
                                    .placeholder
                            }}"
                            (focus)="dropDownRelationType.toggle(true)"
                            (selectionChange)="onFieldSelectionChange($event)"
                        >
                        </kendo-combobox>
                    </div>
                    <div class="child-source-col">
                        <kendo-dropdownlist
                            [popupSettings]="{ appendTo: 'component' }"
                            class="source-type-ctrl"
                            [(ngModel)]="relationItem.selectedChildEntitySrc"
                            [data]="entitySourceTypes"
                            [filterable]="false"
                            textField="text"
                            valueField="value"
                            (selectionChange)="
                                onChildSourceSelectionChange(
                                    $event,
                                    relationItem
                                )
                            "
                        ></kendo-dropdownlist>
                    </div>
                    <div class="child-entity-col">
                        <multi-sel-dropdown-filter
                            *ngIf="
                                isChildSourceField(
                                    relationItem.selectedChildEntitySrc
                                )
                            "
                            [dropdownConfig]="relationItem.childFieldDataSource"
                            [anchorAlign]="{
                                horizontal: 'left',
                                vertical: 'bottom'
                            }"
                            autoFucus="True"
                        >
                        </multi-sel-dropdown-filter>
                        <kendo-multiselect
                            *ngIf="
                                !isChildSourceField(
                                    relationItem.selectedChildEntitySrc
                                )
                            "
                            #childEntityList
                            [data]="
                                relationItem.childEntityDataSource
                                    .filteredDataSource
                            "
                            textField="shortName"
                            valueField="id"
                            placeholder="{{
                                'general.child_entities' | stringLiterals
                            }}"
                            [loading]="
                                relationItem.childEntityDataSource.isLoading
                            "
                            [filterable]="true"
                            (filterChange)="
                                handleEntitiesFilter(
                                    $event,
                                    relationItem.childEntityDataSource,
                                    childEntityList
                                )
                            "
                            [autoClose]="true"
                            [(ngModel)]="
                                relationItem.childEntityDataSource
                                    .selectedEntityItems
                            "
                            (mousedown)="$event.preventDefault()"
                            (open)="
                                beforeEntitiesDropdownOpen(
                                    $event,
                                    childEntityList
                                )
                            "
                            (valueChange)="
                                onChildEntitySelectionChange(
                                    $event,
                                    relationItem
                                )
                            "
                        >
                            <ng-template kendoMultiSelectHeaderTemplate>
                                <div class="popup-template-clear-header">
                                    <span
                                        class="multiselect-Clear"
                                        (click)="clearValue()"
                                        >Clear</span
                                    >
                                </div>
                            </ng-template>
                            <ng-template
                                kendoMultiSelectItemTemplate
                                let-dataItem
                            >
                                <tam-entity-dropdown-item
                                    [entity]="dataItem"
                                ></tam-entity-dropdown-item>
                            </ng-template>
                        </kendo-multiselect>
                    </div>
                    <div class="operation-type-col">
                        <div
                            class="option-div left-radius"
                            [ngClass]="{ selected: relationItem.isAppend }"
                            (click)="
                                onRelationOperationChange(relationItem, true)
                            "
                        >
                            {{ "general.append" | stringLiterals }}
                        </div>
                        <div
                            class="option-div"
                            [ngClass]="{ selected: !relationItem.isAppend }"
                            (click)="
                                onRelationOperationChange(relationItem, false)
                            "
                        >
                            {{ "general.replace" | stringLiterals }}
                        </div>
                    </div>
                    <div class="mapping-operation-col" *ngIf="relationshipSettings.length>1">
                        <smart-icon
                            name="trash"
                            (click)="onDeleteRow(relationItem)"
                            class="light delete-btn small"
                        >
                        </smart-icon>
                    </div>
                </div>
            </div>
            <div
                class="tam-form-help"
                *ngIf="!isRelationshipConfigValid && isSaveBtnClicked"
            >
                {{ "general.required_error_message" | stringLiterals }}
            </div>
            <div class="bottom-toolbar" tid="field-add">
                <!-- mapping add button -->
                <div class="icon-plus">
                    <smart-icon
                        (click)="onAddRowClick()"
                        name="add-cycle"
                        class="light"
                    >
                    </smart-icon>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template #footer>
        <button
            tid="cancel_Automation_Modification"
            tam-button
            tamType="tertiary"
            tamSize="normal"
            class="dialog-button dialog-cancel footer-research-button"
            (click)="onCancelBtnClick($event)"
        >
            {{ "general.cancel" | stringLiterals }}
        </button>
        <button
            tid="save_Automation_Modification"
            tam-button
            tamType="primary"
            tamSize="normal"
            class="dialog-button dialog-publish footer-research-button"
            (click)="onClickSaveBtn($event)"
        >
            {{ "general.save" | stringLiterals }}
        </button>
    </ng-template>
</tam-dialog>
